import { useCallback, useEffect, useState } from 'react'
import toastError from '../../errors/toastError'

import api from '../../services/api'

const useTickets = ({
  isSearch,
  searchParam,
  tags,
  users,
  contactId,
  contactIds,
  noQueue,
  pageNumber,
  limit,
  status,
  groups,
  chatbots,
  date,
  dateFrom,
  dateTo,
  closingDateFrom,
  closingDateTo,
  updatedAt,
  showAll,
  queueIds,
  whatsappIds,
  sortBy,
  sortOrder,
  withUnreadMessages,
  notClosed,
  all
}) => {
  const [loading, setLoading] = useState(true)
  const [hasMore, setHasMore] = useState(false)
  const [count, setCount] = useState(0)
  const [tickets, setTickets] = useState([])
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  useEffect(() => {
    setLoading(true)
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        try {
          const { data } = await api.get('/tickets', {
            params: {
              isSearch,
              searchParam,
              pageNumber,
              limit,
              tags,
              users,
              contactId,
              contactIds,
              noQueue,
              status,
              groups,
              chatbots,
              date,
              dateFrom,
              dateTo,
              closingDateFrom,
              closingDateTo,
              updatedAt,
              showAll,
              queueIds,
              whatsappIds,
              sortBy,
              sortOrder,
              withUnreadMessages,
              notClosed,
              all
            }
          })
          setTickets(data.tickets)
          setCount(data.count)
          setHasMore(data.hasMore)
          setLoading(false)
        } catch (err) {
          setLoading(false)
          toastError(err)
        }
      }
      fetchTickets()
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [
    searchParam,
    tags,
    users,
    contactId,
    contactIds,
    noQueue,
    pageNumber,
    limit,
    status,
    groups,
    chatbots,
    date,
    dateFrom,
    dateTo,
    closingDateFrom,
    closingDateTo,
    updatedAt,
    showAll,
    queueIds,
    whatsappIds,
    sortBy,
    sortOrder,
    withUnreadMessages,
    notClosed,
    all,
    refreshTrigger
  ])

  const refetch = useCallback(() => {
    setRefreshTrigger(prevState => prevState + 1)
  }, [])

  const fetchSince = useCallback(
    async minUpdatedAt => {
      const { data } = await api.get('/tickets', {
        params: {
          isSearch,
          searchParam,
          tags,
          users,
          contactId,
          noQueue,
          status,
          groups,
          chatbots,
          date,
          dateFrom,
          dateTo,
          closingDateFrom,
          closingDateTo,
          updatedAt,
          showAll,
          queueIds,
          whatsappIds,
          sortBy,
          sortOrder,
          withUnreadMessages,
          notClosed,
          all,
          minUpdatedAt
        }
      })
      return data.tickets
    },
    [
      isSearch,
      searchParam,
      tags,
      users,
      contactId,
      contactIds,
      noQueue,
      status,
      groups,
      chatbots,
      date,
      dateFrom,
      dateTo,
      closingDateFrom,
      closingDateTo,
      updatedAt,
      showAll,
      queueIds,
      whatsappIds,
      sortBy,
      sortOrder,
      withUnreadMessages,
      notClosed,
      all
    ]
  )

  return { tickets, count, loading, hasMore, refetch, fetchSince }
}

export default useTickets
